
export default {
  name: 'VsCounter',
  inheritAttrs: false,
  props: {
    value: {
      type: Number,
      default: 0
    },
    step: {
      type: Number,
      default: 1
    },
    interval: {
      type: Number,
      default: null
    },
    decimals: {
      type: Number,
      default: 0
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  watch: {
    value() {
      this.counter = 0
      this.increment()
    }
  },
  data() {
    return {
      counter: 0,
      timer: null
    }
  },
  computed: {
    delay() {
      return this.interval || this.value / 10000
    }
  },
  methods: {
    increment() {
      clearInterval(this.timer)

      this.timer = setInterval(() => {
        if (this.counter < this.value) {
          const diff = this.value - this.step
          let step = diff < this.step ? diff : this.step
          step = step < 1 ? 1 : step

          this.counter = this.counter + step
        } else {
          clearInterval(this.timer)
          this.timer = null
        }
      }, this.delay)
    }
  },
  mounted() {
    this.increment()
  }
}
